import { apiCall } from "../../../../../_utils";
import { apiUrls } from "../../../../../_constants";

export const publishService = {
  getAllInstructorPosts,
  getPost,
  addInstructor,
  getInstructor,
  deleteDraft
};

function getAllInstructorPosts(params) {
  return apiCall("GET", `${apiUrls.posts.base}`, null, params);
}

function addInstructor(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.instructors.base;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getInstructor(id) {
  return apiCall("GET", `${apiUrls.instructors.base}/${id}`);
}

function deleteDraft(id) {
  return apiCall("DELETE", `${apiUrls.posts.base}/${id}`);
}

function getPost(id) {
  return apiCall("GET", `${apiUrls.posts.base}/${id}`);
}
